import { apiPost, apiGet } from './client';

export async function searchProspects(params) {
  return apiPost('/prospects/search', params);
}

export async function listProspects(query = {}) {
  // Filter out undefined/null/empty values
  const cleaned = {};
  for (const [k, v] of Object.entries(query)) {
    if (v != null && v !== '') cleaned[k] = v;
  }
  const qs = new URLSearchParams(cleaned).toString();
  return apiGet(`/prospects/list${qs ? `?${qs}` : ''}`);
}

export async function getProspect(prospectId) {
  return apiGet(`/prospects/${prospectId}`);
}

export async function generateBriefs(prospectIds, icpCriteria, voiceProfileJobId) {
  return apiPost('/prospects/brief', { prospectIds, icpCriteria, voiceProfileJobId });
}

export async function deleteProspect(prospectId) {
  return apiPost(`/prospects/${prospectId}/delete`, {});
}
